React = require 'react'
{ Component, PropTypes } = React

class HelpBlock extends Component
	@propTypes:
		help: PropTypes.string

	render: =>
		{ help } = @props

		return null unless help

		React.createElement("span", {"className": "help-block"}, (help))

module.exports = HelpBlock



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/a2i/js/components/HelpBlock.cjsx